import { BaseContext } from '../../../utils/basecontext';

export class BuyToneBuilder 
{
    constructor(private packName: any, private context: BaseContext) 
    {
        
    }

    buildAll(): any {
        return this.parsePackStatusDetailsResponse();
    }

    private parsePackStatusDetailsResponse(): void    {
    
        this.context.getUserContext().setPackName(this.packName);
       
        
        let packNames = this.context.getConfigurationSettings().getPropertyBasedOnLanguage("PACKNAME");

        packNames.split("|").forEach((packName: string) =>
        {
            let packs = packName.split(",");
            if(packs[0] === this.packName)
            {   
                this.context.getUserContext().setPackDisplayName(packs[1]);
            }
        });

        this.context.setUserContext(this.context.getUserContext());
      
       
    }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/buytone/buytonebuilder.tsx